import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import PropTypes from "prop-types";
import React from "react";
import Button from "web/react/components/button/button";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./save-for-later.css";

const basePropTypes = {
    className: PropTypes.string,
    isSaved: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    cta: PropTypes.string,
    features: PropTypes.object,
};

export function SaveForLaterIcon({ onClick, isSaved, className }) {
    const bausteinClass = "save-for-later-button";
    let iconClass = `${bausteinClass}--icon`;
    className = classnames(bausteinClass, iconClass, className, {
        [`${iconClass}-saved`]: isSaved,
    });
    return (
        <button onClick={onClick} className={className}>
            <SVGIcon name="heart" />
        </button>
    );
}

SaveForLaterIcon.propTypes = basePropTypes;

function getCTA(isSaved) {
    if (isSaved) {
        return gettext("in_stock_product.saved");
    } else {
        return gettext("save_for_later.cta.variant_b");
    }
}

export function SaveForLaterNormal({ onClick, isSaved, isSaving, className, cta, features }) {
    let buttonStyle = "secondary";
    if (features.pmt_580_new_colour_scheme) {
        buttonStyle = "primary";
    }

    return (
        <Button
            styleType={isSaved ? "temp-grey" : buttonStyle}
            onClick={onClick}
            className={className}
            fullWidth
            disabled={isSaving}
        >
            <SVGIcon className={styles.svg} name={isSaved ? "heart" : "heart-empty"} />{" "}
            <span>{cta ? cta : getCTA(isSaved)}</span>
        </Button>
    );
}
SaveForLaterNormal.propTypes = basePropTypes;

export function SaveForLaterStockAlert({ onClick, isSaved, isSaving, className, cta }) {
    let ctaText;
    if (isSaved) {
        ctaText = getCTA(isSaved);
    } else {
        ctaText = cta ? cta : getCTA(isSaved);
    }
    return (
        <Button
            styleType={isSaved ? "temp-grey" : "primary"}
            onClick={onClick}
            className={className}
            disabled={isSaving}
        >
            <SVGIcon className={styles.svg} name={"bell"} /> <span>{ctaText}</span>
        </Button>
    );
}

SaveForLaterStockAlert.propTypes = basePropTypes;

const BUTTON_TYPES = {
    icon: SaveForLaterIcon,
    normal: SaveForLaterNormal,
    stockAlert: SaveForLaterStockAlert,
};

function SaveForLater({ type, ...props }) {
    let Component = BUTTON_TYPES[type];
    if (!Component) {
        throw new Error(`Invalid button type ${type}!`);
    }

    return <Component {...props} />;
}

export default SaveForLater;

SaveForLater.propTypes = {
    ...basePropTypes,
    type: PropTypes.oneOf(["icon", "normal", "stockAlert"]).isRequired,
};

SaveForLater.defaultProps = {
    isSaving: false,
};
